import { Ingredient } from './ingredient.model';
import { Currency } from './currency.model';
import { InvestmentZone } from './investment-zone.model';

export class Product extends Ingredient {
  public is_private: boolean;
  public type: string;
  public currency: Currency;
  public investment_zone: InvestmentZone;
  public factor_intensity: number;
  public returns: number;
  public sharpe_ratio: number;
  public maximum_drawdown: number;
  public esg: number;
}
